import React from 'react';
import styled from 'styled-components';
import { SVGFooter } from '@brokerbay/design-components';
import { useBreakpoint } from 'hooks';

const GateKeeperDefaultPage: React.FC<{}> = ({ children }) => {
  const { sm, lg } = useBreakpoint();

  return (
    <>
      <StyledWrapper $sm={sm} $lg={lg}>
        <StyledHeaderLogo src="/img/supraLogo.svg" alt="Logo" />
        {children}
        <StyledFooterLogo />
      </StyledWrapper>
    </>
  );
};

export default GateKeeperDefaultPage;

const StyledHeaderLogo = styled.img`
  position: absolute;
  margin: auto;
  top: calc(5px + 2vh);
  left: 0;
  right: 0;
  width: calc(95px + 3.8vw);
`;

const StyledFooterLogo = styled(SVGFooter)`
  position: absolute;
  margin: auto;
  bottom: 10vmax;
  left: 0;
  right: 0;
  width: calc(10px + 2vmax);
`;

const StyledWrapper = styled.main<{
  $sm: boolean;
  $lg: boolean;
}>`
  min-height: 100vh;
  position: relative;
  padding-top: calc(70px + 4vh);
  padding-bottom: calc(200px + 5vw);
  background-color: white;
  background-image: url(/img/gate-bg.svg);
  background-size: min(300%, 1320px) auto;
  background-repeat: no-repeat;
  background-position: bottom center;
  ${({ $sm }) =>
    !$sm &&
    `background-size: 90% auto;
    padding-bottom: calc(100px + 1vw);
    & > ${StyledFooterLogo} {
      width: calc(12.5px + 1vw);
      bottom: calc(5px + 5vw);
    }`}

  ${({ $lg }) =>
    !$lg &&
    `background-size: 80% auto;
    padding-bottom: calc(150px + 2vw);
    & > ${StyledFooterLogo} {
      width: calc(15px + 1vw);
      bottom: 5vw;
    }`}
`;
